<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0703 5.64062C12.5586 5.15234 13.3594 5.15234 13.8477 5.64062L14.6094 6.40234C15.0977 6.89062 15.0977 7.69141 14.6094 8.17969L13.6719 9.11719L11.1328 6.57812L12.0703 5.64062ZM10.6836 7.02734L13.2227 9.56641L8.67188 14.1172C8.47656 14.3125 8.22266 14.4688 7.94922 14.5469L5.58594 15.25C5.42969 15.2891 5.25391 15.25 5.13672 15.1133C5 14.9961 4.96094 14.8203 5.01953 14.6641L5.70312 12.3008C5.78125 12.0273 5.9375 11.7734 6.13281 11.5781L10.6836 7.02734Z"
      fill="currentColor"
    />
  </svg>
</template>
